import { addAndInitBlock } from "dbot/src/DbotActions";
import { fetchBlock } from "dbot/src/business/DbotHelperFunctions";


export const DbotMiddlewarePlugin = {
    TAGS_TO_IGNORE: [],
    evaluateSpecialBehavior: (payload, dispatch, state) => {        
        if (payload.button && payload.button.tag) {
            payload.button.tag.forEach((t) => processTag(t, dispatch, state, payload.button));
        }            
    },
    persistenceFs: (state) => ({
        saveRecords: (records) => {
        },
        savePointers: (pointers) => {
        },
    }),
};

const processTag = (tag, dispatch, state, button) =>  {
    if (tag.code === 'save-in-db') {
        saveInDb(state.clientId, `${tag.value}#${(new Date()).toISOString()}`, button.textInput)
    }
    if (window.EXTRA_PROCESS_TAG) {
        return window.EXTRA_PROCESS_TAG(tag, dispatch, state, addAndInitBlock, fetchBlock, button)
    }
}


const saveInDb = (clientId, type, value) => {
    //@ts-ignore
    const url = window.OPSEEKER_CONFIG.DB_API;
    if (!url) return;
    const body = { clientId, type, value }
    const params = {
        headers: {
            "content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(body),
        method: "POST",
    };
    return fetch(url, params)
        .then(() => console.log(`Saved :  ${JSON.stringify(body)}`))
        .catch((err) => console.log(err));
};
